<div *ngIf="profile" class="wrap">
    <button class="close-button" (click)="closeModal()"><span class="icon-close"></span></button>
    <header>
        <h3 class="heading">{{ 'pages.userRecords.deleteDialog.deleteHeader' | translate : { firstName: profile.firstName, lastName: profile.lastName, organisation: organisation } }} 
        </h3>
    </header>
    <div class="content" *ngIf="profile">
        <div class="col-wrap">
            <div class="col">
                <span class="box">
                    <i class="icon-warning"></i>
                </span>
            </div>
            <div class="col">
                <span class="box">
                    <h3 class="dangerText"> {{ 'pages.userRecords.deleteDialog.warning' | translate }}</h3>
                </span>
            </div>
            <div class="col userBox">
                <div>
                    <img *ngIf="profile.picture" [src]='profile.picture' alt="profile picture">
                    <img class="user-avatar" *ngIf="!profile.picture" src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" alt="demo-avatar">
                </div>
                <div class="userInformation">
                    <div class="nameText">
                        {{ profile.firstName }} {{ profile.lastName }}
                    </div>
                    <div class="emailText">
                        {{ profile.email }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer>
        <button class="bciti-button bciti-button-white" (click)="closeModal()">{{ 'pages.userRecords.deleteDialog.cancelButton' | translate }}</button>
        <button class="bciti-button bciti-button--blue" (click)="deleteUser()">{{ 'pages.userRecords.deleteDialog.deleteButton' | translate }}</button>
    </footer>
</div>
